import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Room, RoomEvent } from "livekit-client";
import { toast } from "sonner";
import { useLiveKit } from "../contexts";

export const useRoomDisconnect = (room: Room | null) => {
  const navigate = useNavigate();
  const { disconnect } = useLiveKit();

  useEffect(() => {
    if (!room) return;

    const handleDisconnect = () => {
      toast.info("Đã rời khỏi cuộc họp");
      navigate("/meetings");
    };

    room.on(RoomEvent.Disconnected, handleDisconnect);

    return () => {
      room.off(RoomEvent.Disconnected, handleDisconnect);
      void disconnect().catch(() => undefined);
    };
  }, [room, navigate, disconnect]);
};

